<template>
  <div class="content">
    <div class="top">
      <Swipe class="my-swipe" :autoplay="3500" indicator-color="white">
        <SwipeItem v-for="(item, index) of bannerList" :key="index">
          <img class="banner" :src="item.url" alt="" srcset="" />
        </SwipeItem>
      </Swipe>
      <div class="modular-box">
        <van-tabs v-model="active" title-active-color="#04AA96" tabs-bottom-bar-color="#04AA96">
          <van-tab
          :title="item.businessName"
          v-for="(item, index) of modularList"
          :key="index"
          style="margintop: 20px"
        >
          <div class="modular" >
            <div class="modular1List">
              <div
                @click="jump(item1)"
                v-for="(item1, index) of item.businessList"
                :key="index"
                class="item"
              >
                <img class="icon" :src="item1.moduleIcon" alt="" />
                <div class="modularName">{{ item1.moduleName }}</div>
              </div>
            </div>
          </div>
          </van-tab>
        </van-tabs>
      </div>
      <div class="modular">
        <div class="title-box">
          <div class="title">{{ modularList1.businessName }}</div>
        </div>
        <div class="modular1List">
          <div
            @click="jump(item)"
            v-for="(item, index) of modularList1.businessList"
            :key="index"
            class="item"
          >
            <img class="icon" :src="item.moduleIcon" alt="" />
            <div class="modularName">{{ item.moduleName }}</div>
          </div>
        </div>
      </div>
    </div>

      <Footer />

    <van-dialog
      v-model="show"
      title="绑定手机号"
      show-cancel-button
      @confirm="confirm"
      confirm-button-text="立即绑定"
      confirm-button-color="#0587FE"
      cancel-button-color="#878787"
      :before-close="onBeforeClose"
    >
      <div class="dialogItem">
        <div class="label">手机号 <i></i></div>
        <input
          v-model="dialogFrom.mobileno"
          placeholder="请输入手机号"
          type="text"
        />
      </div>
      <div class="dialogItem">
        <div class="label">密码 <i></i></div>
        <input v-model="dialogFrom.pwd" placeholder="请输入密码" type="text" />
      </div>
      <div class="dialogItem dialogCode">
        <input
          v-model="dialogFrom.code"
          placeholder="请输入验证码"
          type="text"
        /><Button
          :disabled="isDisabled"
          @click="getCode"
          class="btn"
          type="info"
          >{{ sendName }}</Button
        >
      </div>
    </van-dialog>
  </div>
</template>

<script>
import { Swipe, SwipeItem, Dialog, Form, Field, Button, Toast } from "vant";
import md5 from "md5";
import Footer from "@/components/Footer";
import {
  BASEURL,
  GETALLBUSINESS,
  GETMETERLIST,
  SENDAUTHCODE,
  MOBILEBINDNO,
  MOBILEBINDCHECK,
  WSTGRT_USER,
} from "@/api/ApiConfig";
import { isWeiXin } from "@/utils/functionUtil";

export default {
  name: "home",
  components: {
    Swipe,
    SwipeItem,
    Footer,
    [Dialog.Component.name]: Dialog.Component,
    Form,
    Field,
    Button,
    Toast,
  },
  data() {
    return {
      active:0,
      show: false,
      modularList: [],
      modularList1:{},
      dialogFrom: {
        mobileno: "",
        pwd: "",
        code: "",
      },
      bannerList:[
        {
          url:require(`@/assets/msbIMG/bannner.jpg`)
        }
      ],
      sendName: "获取验证码",
      timer: null,
      second: 60,
      isDisabled: false,
    };
  },
  async mounted() {
    if (
      this.$route.query.token == "null" ||
      this.$route.query.token == "undefined" ||
      this.$route.query.token == null ||
      this.$route.query.token == undefined ||
      this.$route.query.token == ""
    ) {
    } else {
      window.localStorage.setItem("token", this.$route.query.token);
      window.sessionStorage.setItem("token", this.$route.query.token);
      window.sessionStorage.setItem("openId", this.$route.query.openId);
      window.sessionStorage.setItem("userMobile", this.$route.query.userMobile);
      window.localStorage.setItem("openId", this.$route.query.openId);
      window.localStorage.setItem("userMobile", this.$route.query.userMobile);
      window.localStorage.setItem("apiType", this.$route.query.apiType?this.$route.query.apiType:null);
      window.sessionStorage.setItem("apiType", this.$route.query.apiType?this.$route.query.apiType:null);
    }
    this.getHomeInfo();//菜单
    this.getUserMeterList();//获取户号列表
    this.getisShowbindPhone();
    this.getiusadPhone();
  },
  methods: {
    getiusadPhone(){
      this.$ajax({
          url: WSTGRT_USER,
          baseURL: BASEURL,
          method: "get",
          params: {
            token:window.localStorage.getItem('token'),
          },
        }).then((res) => {
         window.localStorage.setItem("userdata", JSON.stringify(res.data));
        });
    },
    onBeforeClose(action, done) {
      if (action == "confirm") {
        return done(false);
      } else {
        return done();
      }
    },
    getisShowbindPhone() {
      if (!isWeiXin()) {
        this.$request({
          url: MOBILEBINDCHECK,
          baseURL: BASEURL,
          method: "post",
          params: {},
        }).then((res) => {
          if (res.message == "用户未绑定") {
            this.show = true;
          }else{
            this.show = false;
          }
        });
      }
    },
    confirm() {
      let myreg = /^[1][3,4,5,7,8][0-9]{9}$/;
      if (!myreg.test(this.dialogFrom.mobileno)) {
        Toast("手机号格式不正确");
        return;
      }
      if (!this.dialogFrom.pwd) {
        Toast("请输入密码");
        return;
      }
      if (!this.dialogFrom.code) {
        Toast("请输入验证码");
        return;
      }
      this.$request({
        url: MOBILEBINDNO,
        baseURL: BASEURL,
        method: "post",
        params: {
          authCode: this.dialogFrom.code,
          mobileno: this.dialogFrom.mobileno,
          password: md5(this.dialogFrom.pwd),
          waterCorpId: 3,
        },
      }).then((res) => {
        if (!res.status) {
          this.show = false;
        }
        Toast(res.message);
      });
    },
    getCode() {
      let myreg = /^[1][3,4,5,7,8][0-9]{9}$/;
      if (!myreg.test(this.dialogFrom.mobileno)) {
        Toast("手机号格式不正确");
        return;
      }
      this.$request({
        url: SENDAUTHCODE,
        baseURL: BASEURL,
        method: "post",
        params: {
          type: 3,
          mobile: this.dialogFrom.mobileno,
        },
      }).then((res) => {
        if (!res.status) {
          this.timer = setInterval(() => {
            this.second--;
            this.sendName = this.second + "秒后重发";
            this.isDisabled = true;
            if (this.second < 0) {
              this.sendName = "获取验证码";
              this.isDisabled = false;
              this.second = 60;
              clearInterval(this.timer);
            }
          }, 1000);
          Toast.success(res.message);
        } else {
          Toast.fail(res.message);
        }
        console.log(res);
      });
    },
    jump(item) {
      // console.log(item,'item',sessionStorage.getItem("UserMeterList"))
      switch (item.moduleName) {
          case "户号绑定":
            this.$router.push({
              path: "/householdList",
              // path: "/outlets",
            });
            break;
          case "水费查缴":
            this.$router.push({
              path: "/waterFeePayment",
            });
            break;
          case "电子发票":
            this.$router.push({
              path: "/Invoice",
            });
            break;
            case "进度查询":
            this.$router.push({
              path: "/commonFunctions",
            });
            break;
             case "业务办理进度":
            this.$router.push({
              path: "/commonFunctions",
            });
            break;
          case "用水清单":
            this.$router.push({
              path: "/waterBill",
            });
            break;
            case "户号查询":
            this.$router.push({
              path: "/houseSearch",
            });
            break;
          case "问卷调查":
            this.$router.push({
              path: "/iserSurveyHomepage",
            });
            break;
          case "抄表员查询":
            this.$router.push({
              path: "/meterReaderQuery",
            });
            break;
          case "营业网点":
            this.$router.push({
              // path: "/businessOutlets",
              path: "/outlets",
            });
            break;
          case "网点导航":
            this.$router.push({
              path: "/outlets",
            });
            break;
          case "服务承诺":
            this.$router.push({
              path: "/serviceCommitment",
            });
            break;
          case "水价信息":
            this.$router.push({
              path: "/waterPriceinformation",
            });
            break;
            case "信息公示":
            this.$router.push({
              path: "/filemenu",
            });
            break;
          default:
            let query ={
                moduleName: item.moduleName,
                moduleId: item.moduleId,
                flowcode: item.flowcode ? item.flowcode : null,
                systemcode: item.moduleId ? item.moduleId : "AS",
                moduleTypeList: JSON.stringify(item.moduleTypeList)
                  ? JSON.stringify(item.moduleTypeList)
                  : null,
                isPersonal: item.isPersonal,
            }
            this.$router.push({
              path: "/applicateIndex",  // waterServer
              query: {
                params:JSON.stringify(query)
              },
            });
            break;
        }
        return


      if (item.isTemplate) {
        // if (JSON.parse(sessionStorage.getItem("UserMeterList")).length == 0) {
        //   Dialog.confirm({
        //     title: "温馨提示",
        //     message: "您还没有绑定户号，暂时不能使用此功能。",
        //   })
        //     .then(() => {
        //       this.$router.push({
        //         path: "/householdBinding",
        //       });
        //     })
        //     .catch(() => {});
        //   return;
        // }
        
        
      } else {
        
      }
    },
    getHomeInfo() {
      this.$request({
        url: GETALLBUSINESS,
        baseURL: BASEURL,
        method: "get",
        params: {},
      }).then((res) => {
        this.modularList1 = res.allBusinessListVols[0];
        res.allBusinessListVols.shift()
        this.modularList = res.allBusinessListVols;
      });
    },
    getUserMeterList() {
      this.$request({
        url: GETMETERLIST,
        baseURL: BASEURL,
        method: "post",
        params: {},
      }).then((res) => {
        sessionStorage.setItem("UserMeterList", JSON.stringify(res.data));
      });
    },
  },
};
</script>

<style lang="less" scoped>
.modular-box{
  background: #fff;
  /deep/.van-tabs__line {
    background-color: #04AA96;
  }
}
.content {
  // background-color: #fff;
  // height: 100vh;
  .banner {
    width: 100%;
    height: 220px;
  }
}
.top {
  width: 100%;
  height: auto;
}
.content {
  .van-swipe-item{
    text-align: center;
    background: #FFFFFF;
  }
  .modular {
    // height: 4.31rem;
    margin: auto;
    box-sizing: border-box;
    // background-image: url("~@/assets/img/banner2.png");
    // background-size: 100% 100%;
    padding-top: 0.2rem;
    box-sizing: border-box;
    background: #FFFFFF;
    .title-box{
      width: 100%;
      height:1rem;
      font-size: 1.8rem;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #4B4B4B;
      line-height: 2.6rem;
      background: #F9F9F9;
      .title {
        width: 85%;
        height:1rem;
        text-align: left;
      font-size: 0.3rem;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #4B4B4B;
        line-height: 1rem;
        margin: 0 auto;
      }
    }
    
    .modular1List {
      display: flex;
      flex-wrap: wrap;
      width: 92%;
      margin: 0 auto;
      margin-top: 0.1rem;
      .item {
        width: 25%;
        text-align: center;
        margin-top: 0.1rem;
        .icon {
          width: 0.8rem;
          height: 0.8rem;
        }
        .modularName {
          font-size: 0.24rem;
          font-weight: 400;
          color: #666666;
          position: relative;
          top: -0.15rem;
        }
      }
    }
  }
  .modular:last-child{
    padding-bottom: 0.45rem;
  }
  // .modular:nth-last-child(4){
  //   padding-bottom: 0.45rem;
  // }
  .footerBanner {
    position: relative;
    img {
      width: 100%;
    }
    span {
      position: absolute;
      font-size: 0.4rem;
      font-family: lixukexingshu;
      color: #012a43;
      margin-left: 50%;
      margin-top: 13%;
      transform: translate(-50%);
    }
  }
}
.dialogItem {
  display: flex;
  justify-content: center;
  align-items: baseline;
  margin-top: 0.2rem;
  .label {
    width: 0.9rem;
    text-align: justify;
    font-size: 0.3rem;
    font-weight: 400;
    color: #000000;
    i {
      display: inline-block;
      width: 100%;
    }
  }
  input {
    border-radius: 0.08rem;
    border: 0.02rem solid #d7d7d7;
    width: 4rem;
    height: 0.68rem;
    margin-left: 0.2rem;
    padding-left: 0.2rem;
    box-sizing: border-box;
  }
}
.dialogCode {
  align-items: center;
  margin-bottom: 0.3rem;
  input {
    width: 2.64rem;
    margin-left: 0rem;
  }
  .btn {
    width: 2.22rem;
    height: 0.74rem;
    margin-left: 0.28rem;
  }
}
::v-deep .van-dialog__content {
  margin-top: 0.35rem;
}
::-webkit-input-placeholder {
  /* WebKit, Blink, Edge */
  font-size: 0.3rem;
  font-weight: 400;
  color: #878787;
}
</style>
